import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Footer } from './components/footer/footer';



@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, Footer],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('RevanceSecuritiesII');
}























//import { HttpClient } from '@angular/common/http';
//import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
//import { WeatherForecast } from './models/weatherforcast';

//@Component({
//  selector: 'app-root',
//  templateUrl: './app.html',
//  standalone: false,
//  styleUrl: './app.css',

//})
//export class App implements OnInit {
//  //forecasts: any = [];

//  //constructor(private cdr: ChangeDetectorRef, private http: HttpClient) { }

//  ngOnInit() {
//    /*this.loadForecasts();*/

//  }

//  //loadForecasts() {
//  //  this.http.get("assets/Forecasts.json").subscribe(data => {
//  //    console.log(data);
//  //    this.forecasts = data;
//  //    this.cdr.detectChanges(); // Manually runs change detection
//  //  })
//  //}

//  //getForecasts() {
//  //  this.http.get<WeatherForecast[]>('/weatherforecast').subscribe(
//  //    (result) => {
//  //      this.forecasts = result;
//  //      console.log(this.forecasts);
//  //    },
//  //    (error) => {
//  //      console.error(error);
//  //    }
//  //  );
//  //}

//  /*  protected readonly title = signal('testtemplate.client');*/
//}
